import React from 'react'
import logoLight from '../../assets/img/logo.svg'
import logoDark from '../../assets/img/logo-dark-mode.svg'

import type { ImageProps } from '@ztechapps/webui.util'
import { Image } from '@ztechapps/webui.util'
import { useTheme } from '@ztechapps/common.hook'
export default function Logo(props: Partial<ImageProps>) {
  const { colorMode } = useTheme()
  const logo = colorMode.isDark ? logoDark : logoLight

  return <Image {...props} url={logo} name="App Logo" />
}
